<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{ 'group-buddy.buddy_instance_swap_modal_title' | translate }}</h1>
<div class="content-height" mat-dialog-content>
  <!-- First buddy -->
  <div>
    <mat-form-field class="full-width mb-2">
      <mat-label>{{ 'group-buddy.select_active_buddy_instance' | translate }}</mat-label>
      <mat-select
        [attr.id]="'selectedBuddyInstance1'"
        (selectionChange)="onChangeSelection1()"
        [(value)]="selectedBuddyInstance1"
      >
        <mat-option
          [attr.id]="'option_' + buddy.id"
          *ngFor="let buddy of buddySelection1"
          [value]="buddy"
        >
          {{ 'group-buddy.buddy_instance_id' | translate }} #{{ buddy.id }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width mb-2">
      <mat-label>{{ 'group-buddy.select_buddy_to_remove' | translate }}</mat-label>
      <mat-select
        [attr.id]="'selectedBuddyToRemove'"
        (selectionChange)="onChangeUserSelection()"
        [(ngModel)]="selectedBuddyToRemove"
        [disabled]="!selectedBuddyInstance1"
      >
        <mat-option
          [attr.id]="'option_' + user.id"
          *ngFor="let user of buddyMembers1"
          [value]="user"
        >
          {{ user.attributes.email }}
          <span *ngIf="helper.getStudyCode(studyId, user)" class="break-word">
            ({{ helper.getStudyCode(studyId, user) }})
          </span>
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="selectedBuddyInstance1 && buddyMembers1?.length === 0" class="text-info">
        {{ 'group-buddy.buddy_user_required' | translate }}
      </mat-hint>
    </mat-form-field>
  </div>

  <hr />

  <!-- Second buddy -->
  <div>
    <mat-form-field class="full-width mb-2">
      <mat-label>{{ 'group-buddy.select_inactive_buddy_instance' | translate }}</mat-label>
      <mat-select
        [attr.id]="'selectedBuddyInstance2'"
        (selectionChange)="onChangeSelection2()"
        [(value)]="selectedBuddyInstance2"
      >
        <mat-option
          [attr.id]="'option_' + buddy.id"
          *ngFor="let buddy of buddySelection2"
          [value]="buddy"
        >
          {{ 'group-buddy.buddy_instance_id' | translate }} #{{ buddy.id }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width mb-2">
      <mat-label>{{ 'group-buddy.select_buddy_to_add' | translate }}</mat-label>
      <mat-select
        [attr.id]="'selectedBuddyToAdd'"
        (selectionChange)="onChangeUserSelection()"
        [(ngModel)]="selectedBuddyToAdd"
        [disabled]="!selectedBuddyInstance2"
      >
        <mat-option
          [attr.id]="'option_' + user.id"
          *ngFor="let user of buddyMembers2"
          [value]="user"
        >
          {{ user.attributes.email }}
          <span *ngIf="helper.getStudyCode(studyId, user)" class="break-word">
            ({{ helper.getStudyCode(studyId, user) }})
          </span>
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="selectedBuddyInstance2 && buddyMembers2?.length === 0" class="text-info">
        {{ 'group-buddy.buddy_user_required' | translate }}
      </mat-hint>
    </mat-form-field>
  </div>

  <div *ngIf="isAllSelected()">
    <p class="text-info">{{ 'group-buddy.inactive_buddy' | translate:param1 }}</p>
    <p class="text-info">{{ 'group-buddy.active_buddy' | translate:param2 }}</p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button [attr.id]="'btnCancel'" mat-button mat-dialog-close>
    {{ 'group-buddy.cancel' | translate }}
  </button>
  <app-button-feedback
    [_setId]="'btnSwapBuddyConnection'"
    (click)="swapBuddyConnection()"
    [_isDisabled]="!isAllSelected() || swapBuddyResponse.value !== 'DEFAULT'"
    [_defaultButtonText]="'group-buddy.buddy_instance_swap_modal_title'"
    [_responseText]="swapBuddyResponse | async"
  ></app-button-feedback>
</div>
